import React, { ComponentProps } from 'react';
import { Heading, Text } from '@amzn/storm-ui';

type ObjectInfoProps = {
  value: {
    title: string;
    description?: string;
  };
  renderAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: ComponentProps<typeof Heading>['size'];
  withMargin?: boolean;
};

const ObjectInfo = (props: ObjectInfoProps) => {
  const { value, size = 'base', withMargin = false, renderAs = 'h3' } = props;
  const { title, description } = value;

  return (
    <>
      <Heading renderAs={renderAs} size={size} withMargin={withMargin}>
        {title}
      </Heading>
      {description && (
        <Text size={'base'} color={'default'}>
          {description}
        </Text>
      )}
    </>
  );
};

export default ObjectInfo;
